var ReactFlot = require('./lib/ReactFlot').default;
module.exports = ReactFlot;
